import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { GlobeAltOutline, GlobeOutline, LockClosedOutline, UserGroupOutline, UserOutline, UsersOutline } from '@bonusly/design-system';

import { useHomepageRedesignEnabled } from '../../../../../modules/bonus-feed/features/recognition/components/BonusFeed/hooks/useHomepageRedesignEnabled';
import { Privacy } from '../types';

export const usePrivacyOptions = () => {
	const { t } = useTranslation('action_input');
	const isHomepageRedesignEnabled = useHomepageRedesignEnabled();

	return useMemo(() => {
		if (isHomepageRedesignEnabled) {
			return [
				{
					description: t('privacy.public_description_redesign'),
					icon: <GlobeAltOutline boxSize={4} color="text.soft" />,
					label: t('privacy.public_redesign'),
					value: Privacy.Public,
				},
				{
					description: t('privacy.team_description_redesign'),
					icon: <UsersOutline boxSize={4} color="text.soft" />,
					label: t('privacy.team_redesign'),
					value: Privacy.Team,
				},
				{
					description: t('privacy.private_description_redesign'),
					icon: <UserOutline boxSize={4} color="text.soft" />,
					label: t('privacy.private_redesign'),
					value: Privacy.Private,
				},
			];
		}

		return [
			{
				description: t('privacy.public_description'),
				icon: <GlobeOutline />,
				label: t('privacy.public'),
				value: Privacy.Public,
			},
			{
				description: t('privacy.team_description'),
				icon: <UserGroupOutline />,
				label: t('privacy.team'),
				value: Privacy.Team,
			},
			{
				description: t('privacy.private_description'),
				icon: <LockClosedOutline />,
				label: t('privacy.private'),
				value: Privacy.Private,
			},
		];
	}, [t, isHomepageRedesignEnabled]);
};
